let script = document.currentScript;
(function() {
  console.log("SCRIPT START");
  let gaListener = (g = undefined) =>
    Object.defineProperty(window, "ga", {
      get() {
        // console.log("GET GA ::");
        return g;
      },
      set(v) {
        // console.log("!! SET GA :: ", v);
        gaListener(v);
        if (!g) {
          UTMParser();
        }
      },
      configurable: true,
      enumerable: true
    });

  if ((script = script.src.split("?")).length < 2) {
    return;
  }

  let utm_keys = [
    "utm_source",
    "utm_placement",
    "utm_creative",
    "utm_medium",
    "utm_term",
    "utm_content",
    "utm_campaign",
    "gclid"
  ];

  /* begin parse utm from page url */
  let mappedUTM = new Map();
  decodeURIComponent(window.location.search)
    .substring(1)
    .split("&")
    .forEach(v => {
      v = v.split("=");
      !utm_keys.includes(v[0]) || mappedUTM.set(v[0], v[1]);
    });
  if (!mappedUTM.size) {
    return;
  }
  console.log("mappedUTM", mappedUTM);
  /* end parse utm from url */

  /* begin parse script settings */
  let d = JSON.parse(atob(script[1]));
  let requestData = new Map(Object.keys(d).map(v => [v, d[v]]));
  if (!requestData.size) {
    return;
  }
  console.log("requestData", requestData);
  /* end parse script settings */

  const UTMParser = function() {
    if (typeof amo_social_button !== "object") {
      console.log("amo social button not found");
      return;
    }
    document.removeEventListener("DOMNodeInserted", UTMParser);

    let data = [...requestData.keys()].reduce((d, entity) => {
      let ids = requestData.get(entity);
      let cf = utm_keys.reduce((r, key) => {
        let value = mappedUTM.get(key);
        !ids[key] ||
          !value ||
          r.push({
            id: ids[key][1],
            values: [{ value: value }]
          });
        return r;
      }, []);
      if (typeof ga === "function") {
        cf = cf.concat(
          Object.keys(ids)
            .filter(v => /^ga./.test(v))
            .reduce((r, v) => {
              let value;
              // eslint-disable-next-line no-undef
              !(value = ga.getAll()[0].get(v.slice(3))) ||
                r.push({
                  id: ids[v][1],
                  values: [{ value: value }]
                });
              return r;
            }, [])
        );
      } else {
        gaListener();
      }
      d[entity] = { custom_fields: cf };
      return d;
    }, {});
    try {
      console.log("DATA", data);
      // eslint-disable-next-line no-undef
      amo_social_button.setMeta(Object.assign({}, data));
    } catch (e) {
      /**/
    }
  };
  document.addEventListener("DOMNodeInserted", UTMParser);
})();
